// collection-tile-accessibility.js
window.addEventListener('DOMContentLoaded', () => {
  const selectors = [
    '.shopify-section--featured-collection .column.thumbnail',
    '.shopify-section--collection-template .column.thumbnail',
    '[data-section-type="product-recommendations"] .gallery-cell',
    '[data-section-type="product-recommendations"] .column.thumbnail'
  ];
  const tiles = document.querySelectorAll(selectors.join(', '));

  tiles.forEach(tile => {
    // 1) Kachel als einziger Tab-Stopp
    tile.setAttribute('tabindex', '0');

    // 2) innere Links/Buttons/Galerien aus dem Flow entfernen
    tile.querySelectorAll(
      'a[href], button, .js-product-gallery, [data-product-gallery], .flickity-viewport'
    ).forEach(el => el.setAttribute('tabindex', '-1'));

    // 3) Klick (außer Quick-Shop) → Produkt-Link
    tile.addEventListener('click', e => {
      if (e.target.closest('.js-quick-shop-link, button')) return;
      const link = tile.querySelector('a[href]');
      if (link) window.location.href = link.href;
    });

    // 4) Enter/Space simuliert Klick
    tile.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        tile.click();
      }
    });
  });
});
